import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import Logo from '../assets/logo.png'
import LogoCircle from '../assets/logo-circle.png'
import emailLogo from '../assets/email.svg'
import instaLogo from '../assets/logo-insta.svg'
import faceLogo from '../assets/logo-face.svg'
import proba from '../prints/proba.png'
import probaEnem from '../prints/probaEnem.png'
import produ from '../prints/produ.png'
import trigo from '../prints/trigo.png'
import siste from '../prints/siste.png'
import porcen from '../prints/porcen.png'
import funcao from '../prints/funcao.png'
import geral1 from '../prints/geral1.png'
import conc from '../prints/conc.png'
import conc2 from '../prints/conc2.png'
import ana from '../prints/ana.png'
import conju from '../prints/conju.png'
import trintamais from '../prints/trintamais.png'
import bonus from '../prints/bonus.png'
import megaLogo from '../assets/mega-logo.png'
import driveLogo from '../assets/drive-logo.png'
import matbasica1 from '../prints/matbasica1.png'
import api from '../config/api'
import CardFiles from '../components/cardFiles'

const linksFiles = [ 
    {
      title: 'Matemática Básica 1',
      shortName: 'matbasica1',
      preview: matbasica1,
      mega: 'https://mega.nz/file/bHxSVZxK#wC4y9KoGo7Pu6kkrerBTm2qTGacg9oSwvmr-jpuG6O0',
      drive: 'https://drive.google.com/file/d/1dJPLBxgT5fRwHuiiaMOjrO7tFzdtMSz6/view?usp=sharing'
    },
    {
      title: 'Bônus das 30+!',
      shortName: 'bonus',
      preview: bonus,
      mega: 'https://mega.nz/file/zK41HAgR#x2U361JuWicmeJLtY7ySa2wZu9IM8HFX-3n1Az1C5Ok',
      drive: 'https://drive.google.com/file/d/1ehTmui6oHE75H-1VcllQhad4e4G4ucl_/view?usp=sharing'
    },
    {
      title: 'As 30+!',
      shortName: 'trintamais',
      preview: trintamais,
      mega: 'https://mega.nz/file/Cah1zAKZ#WOeXUxnVtK8ed0g8qkKyD_Y0MhfWYaum6DUTQLVFudk',
      drive: 'https://drive.google.com/file/d/1JgOH4vWk-GaIvEenJZ2YVxTybYxOOfEq/view?usp=sharing'
    },
    {
      title: 'Conjuntos',
      shortName: 'conju',
      preview: conju,
      mega: 'https://mega.nz/file/PHQEUDTA#v7rgbRMVdtPlP5nJ0I6CFbemSNuDQmzzM6wYk6Q8j9U',
      drive: 'https://drive.google.com/file/d/1dXe6GYDKcigfFxXdqF17ZqbCkQEthsfP/view?usp=sharing'
    },
    {
      title: 'Análise Cobinatória',
      shortName: 'ana',
      preview: ana,
      mega: 'https://mega.nz/file/OP4QhLaR#ZNSCrLQvSAmfHi8wQ7WaZjVwPf29DjvG4tCiP3RGEX0',
      drive: 'https://drive.google.com/file/d/10eDxVrs805U8lvG8l5wRTHzPWNNNgsid/view?usp=sharing'
    },
    {
      title: 'Concursos II',
      shortName: 'concursos2',
      preview: conc2,
      mega: 'https://mega.nz/file/TL5wXJCA#bo1Um4AHLBFiPddQBBqnm2lEENQ9wfzA5Y12d-N34ug',
      drive: 'https://drive.google.com/file/d/1WUtWaDOukbm_AzjpW1S_nsogIZrOiv4E/view?usp=sharing'
    },  
    {
      title: 'Concursos I',
      shortName: 'concursos',
      preview: conc,
      mega: 'https://mega.nz/file/nWpzBCjD#tfulZapSZAmqieR1b3y2YKQV9Hl_hKyKhdyUlWgERDE',
      drive: 'https://drive.google.com/file/d/11wJ_ZuZiN90r5n26mHWDQxaewDUPfL5p/view?usp=sharing'
    },
    {
    title: 'Geral 1',
    shortName: 'geral1',
    preview: geral1,
    mega: 'https://mega.nz/file/ufxiiAZS#z_Fd9SZ4bWAE7l6ye_6cSdNqoWyjUQEEakPcjSxo8yQ',
    drive: 'https://drive.google.com/file/d/11plGZ7dsMOmxpu2Bh6rVcUOJ5BM7HqF-/view?usp=sharing'
  },
  {
    title: 'Função 1',
    shortName: 'funcao',
    preview: funcao,
    mega: 'https://mega.nz/file/6Sh1lSZL#svdwsNKcOiA5cfvWPU2A0WawpwML43fZWiRaOlFOLBk',
    drive: 'https://drive.google.com/file/d/1YZ3EOeUvn0ylyyKL4Pn-WWN7SNMRCbg_/view?usp=sharing'
  },
  {
    title: 'Porcentagem',
    shortName: 'porcen',
    preview: porcen,
    mega: 'https://mega.nz/file/TDRHWYaY#eHRilnI5Dk67pYs-uVxtnwlzs1-nMHpaR2QuvO6acXQ',
    drive: 'https://drive.google.com/file/d/1M6LUYpMeF_R3At3fjwrUjSZ8vT4z0Wp1/view?usp=sharing'
  },
  {
    title: 'Probabilidade 1',
    shortName: 'proba1',
    preview: proba,
    mega: 'https://mega.nz/file/yWxEGKxC#28hDgERFOD1nZf6yh7pj6jnXvFR1QvOjJfZDzDPetUg',
    drive: 'https://drive.google.com/file/d/1FTQATgZchISm47JIxgcRqMdyvH9qxbSc/view?usp=sharing'
  },
  {
    title: 'Probabilidade Enem',
    shortName: 'probaEnem',
    preview: probaEnem,
    mega: 'https://mega.nz/file/qaxnwbaJ#ixi3joF6K7Cc74TPAkLio6PJrJFbtCrb02MH9gmTv6A',
    drive: 'https://drive.google.com/file/d/1NgueVVu7VAK3xSEYdBm1oPcsJ-khrnBg/view?usp=sharing'
  },
  {
    title: 'Trigonometria',
    shortName: 'trigo',
    preview: trigo,
    mega: 'https://mega.nz/file/bCw3WJQD#T81OWKdEUJ5L5yv5LoWepsx-xbCB94laOwPPeMg77iA',
    drive: 'https://drive.google.com/file/d/17_0VWrtKuFi7HNDAqAGA6gMNfu9OIGSa/view?usp=sharing'
  },
  {
    title: 'Prod. Notáveis',
    shortName: 'fatora',
    preview: produ,
    mega: 'https://mega.nz/file/PSAwUSJT#8DNAtfLi41R1tTTGo1PHbRpl0zFuQO7oAWJ2r6YS6fM',
    drive: 'https://drive.google.com/file/d/1LFKRhtsJ0Q5dWsSrE3yqVqoKbKFNQLje/view?usp=sharing'
  },
  {
    title: 'Sistemas Lineares',
    shortName: 'sistemas',
    preview: siste,
    mega: 'https://mega.nz/file/Lb5hiSbT#plcb6vDPTM3Up_ywU1IkTKVtDxmrDihgiK_Qef42krA',
    drive: 'https://drive.google.com/file/d/1XrUBYXJdvk3s0I6yw8eKgu81ug1yNHpu/view?usp=sharing'
  },
]

function validate(values) {
  const errors = {};

  if (!values.email) {
    errors.email = 'Campo obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Digite um email válido';
  }

  return errors;
};

export default function FilesPage({ history }) {

  const [typeError, setType] = useState(false)
  const [email, setEmail] = useState(false)
  const [link, setLink] = useState('')

  useEffect(() => {
    api.get('/')
    setEmail(localStorage.getItem('email'))
  }, [])

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validate,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async values => {
      api.post('/users', values)
        .then(function (response) {
          localStorage.setItem('email', values.email)
          setEmail(values.email)
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.message === "error in requisition of db") {
              setType('Falha interna no servidor tente novamente mais tarde')
              formik.setFieldValue('email', '')
            }
          } else {
            setType('Falha interna no servidor tente novamente mais tarde')
            formik.setFieldValue('email', '')
          }
        });
      window.$('#inseriremail').modal('toggle')
      window.open(link, '_blank')

    },
  });

  return (
    <div className="full p-0 m-0">

      <nav className="navbar navbar-expand-lg navbar-dark bg-edited justify-content-between">

        <a className="navbar-brand" href="/files">
          <img src={LogoCircle} width="35" height="35" alt="Logo" />
        </a>

        <div>
          <a className="navbar-brand pb-2 socialLogos" href="https://www.facebook.com/profile.php?id=100002358731599" target="_blank" rel="noopener noreferrer">
            <img src={faceLogo} width="20" height="20" alt="faceLogo" />
          </a>
          <a className="navbar-brand pb-2 socialLogos" href="https://www.instagram.com/ousadoresolve/" target="_blank" rel="noopener noreferrer">
            <img src={instaLogo} width="20" height="20" alt="instaLogo" />
          </a>
        </div>

      </nav>

      <div className='logo-title-files-page'>
        <img className='mt-4 mb-4' src={Logo} width={3.5 * 68.7} height={3.5 * 37.9} alt="Logo" />
      </div>

     

      <div className='container-fluid bg-edited text-light d-flex flex-column align-items-center p-2'>
       
      <h2 className='infos-files-page' >Confira esse banco de questões comentadas abordando vários assuntos em matemática</h2>
      <h2 className='infos-files-page' >Lembre-se: Complicou? Ousado resolve!</h2>

      </div>


      <div className='container-fluid area-files-page'>
        {
          linksFiles.map((file) => {
            return (<CardFiles  
              shortName={file.shortName}
              preview={file.preview}
              title={file.title}
              email={email}
              megaLink={file.mega}
              driveLink={file.drive}
              megaLogo={megaLogo}
              driveLogo={driveLogo}
              setLink={setLink}
            />)})
          }

      </div>


      <div className="modal fade" id="inseriremail" tabIndex="-1" role="dialog" aria-labelledby="TituloModalCentralizado" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center" id="TituloModalCentralizado">Nos informe seu email para mantermos um controle interno</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Fechar" onClick={() => {
                setType('')
              }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body d-flex flex-column align-items-center">
              <span className='text-dark text-left mb-4' >Não enviaremos span</span>
              <form className='form' onSubmit={formik.handleSubmit}>


                <div className="input-group input-group mb-4 mr-sm-2">
                  {typeError ? <small id="emailHelp" className="infosLogin">{typeError}</small> : null}

                  <div className="input-group-prepend">
                    <div className={formik.errors.email ? "input-group-text borderRed" : "input-group-text"}>
                      <img className="" src={emailLogo} alt="logo" width="18" height="18" />
                    </div>
                  </div>
                  <input
                    className={formik.errors.email ? "form-control borderRed" : "form-control"}
                    id="email"
                    name="email"
                    placeholder='Email'
                    onChange={formik.handleChange}
                    value={formik.values.email}
                  />
                  {formik.errors.email ? <div className='invalid'>{formik.errors.email}</div> : null}
                </div>
                <button className="btn btn-outline-dark btn-block w-100 mb-2 mt-2" type="submit" >Baixar</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

/*
<div className='container-fluid bg-edited text-light d-flex flex-column align-items-center p-2'>
<h2 className='infos-files-page' >Confira esse banco de questões comentadas abordando vários assuntos em matemática</h2>
<h2 className='infos-files-page' >Lembre-se, Complicou? Ousado resolve!</h2>
</div>*/